import {
  IconWrapper,
  IStyles,
  pxToRem,
  pxTovW,
  SelectMenu,
} from '@geneo2-web/shared-ui';
import { Box, Checkbox, MenuItem, Typography } from '@mui/material';

const styles: IStyles = {
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
    gap: { xs: pxToRem(8), md: pxTovW(10) },
  },

  // CheckBoxMenuItem
  checkboxWithItem: {
    borderBottom: '1px solid #96FFC5',
    '&:last-child': { borderBottom: 'none' },
    '&:hover': { background: '#ECFFF5' },
    paddingX: { xs: pxToRem(13), md: pxTovW(10) },
    paddingY: { xs: pxToRem(8), md: pxTovW(12) },
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(15) },
    alignItems: 'center',
    borderRadius: { xs: pxToRem(3), md: pxTovW(3) },
    backgroundColor: '#F1F9FF',
    width: { xs: '100%', md: '100%' },
  },
  checkboxStyle: {
    padding: 0,
    boxSizing: 'border-box',
    maxWidth: 'max-content',
  },
  checkBoxMenuItemTypo: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },
};

interface IModifiedSelectMenu {
  header: string;
  list: { name: string; id: number; checked: boolean }[];
  clearFunction: () => void;
  onChangeCheckbox: (listData: {
    name: string;
    id: number;
    checked: boolean;
  }) => void;
}

export const ModifiedSelectMenu = (props: IModifiedSelectMenu) => {
  const { header, list, clearFunction, onChangeCheckbox } = props;
  return (
    <Box sx={styles.selectContainer}>
      <Typography variant="h4">{header}</Typography>
      <SelectMenu
        placeholder="Select"
        clearIcon
        value={list.filter((listData) => listData.checked)[0]?.name || ''}
        // disabled={list.length === 0}
        onChange={(value: string) => {
          if (value === '') {
            clearFunction();
          }
        }}
        optionList={[]}
        customAdornment={
          <DropdownAdornment
            count={list.filter((listData) => listData.checked).length - 1}
          />
        }
        rootStyles={{
          width: '100%',
          height: { xs: pxToRem(40), md: pxTovW(75), lg: pxTovW(56) },
        }}
        menuNode={
          <>
            {list.map((listData) => (
              <CheckBoxMenuItem
                key={listData.id}
                checked={listData.checked}
                onChangeCheckbox={() => {
                  onChangeCheckbox(listData);
                }}
                menuText={listData.name}
              />
            ))}
          </>
        }
      />
    </Box>
  );
};

// ------------------------------------------------------------

interface IDropdownAdornmentProps {
  count: number;
}

const DropdownAdornment = ({ count }: IDropdownAdornmentProps) => {
  if (count <= 0) return null;

  return (
    <Box
      sx={{
        // position: 'absolute',
        // top: '50%',
        // right: { xs: pxToRem(30), md: pxTovW(65), lg: pxTovW(35) }, // shift it slightly left of dropdown arrow
        // mt: { xs: pxToRem(4), md: pxTovW(2), lg: pxTovW(5) },
        // transform: 'translateY(-50%)',

        backgroundColor: 'primary.main',
        borderRadius: { xs: pxToRem(10), md: pxTovW(20) },
        padding: { xs: pxToRem(4), md: pxTovW(8) },
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: pxToRem(4), md: pxTovW(4) },
      }}
    >
      <IconWrapper
        name="plus-symbol-white"
        size="small"
        parentFolder="icons"
        type="png"
      />
      <Typography
        sx={{
          fontSize: { xs: pxToRem(10), md: pxTovW(14) },
          color: 'common.white',
          fontWeight: '600',
        }}
      >{`${count} more`}</Typography>
    </Box>
  );
};

// ------------------------------------------------------------

interface ICheckBoxMenuItem {
  checked: boolean;
  onChangeCheckbox: () => void;
  menuText: string;
}
const CheckBoxMenuItem = (props: ICheckBoxMenuItem) => {
  const { checked, onChangeCheckbox, menuText } = props;
  return (
    <MenuItem
      onClick={(e) => {
        e.stopPropagation();
        onChangeCheckbox();
      }}
      sx={styles.checkboxWithItem}
    >
      <Checkbox checked={checked} sx={styles.checkboxStyle} />

      <Typography
        variant="h5"
        sx={styles.checkBoxMenuItemTypo}
        fontWeight={checked ? 'bold' : 'regular'}
      >
        {menuText}
      </Typography>
    </MenuItem>
  );
};

// ------------------------------------------------------------
